import type { ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { cn } from '@/lib/utils';

export function ErrorBanner({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <Alert variant="destructive" className={cn('mb-3', className)}>
      <AlertCircle className="size-4" />
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
}

export function EmptyState({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'rounded-lg border border-dashed py-12 text-center text-sm text-muted-foreground',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function ListHeader({
  title,
  action,
}: {
  title: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="mb-4 flex items-center justify-between gap-2">
      <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
      {action}
    </div>
  );
}
